import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { EStorageType } from '@pichincha/angular-sdk/auth'
import { storage } from '@pichincha/angular-sdk/storage'
import { environment } from '../../../environments/environment'
import type { ValidateImageResponse } from '../../interfaces/validate-image-response'
import { EVENT_NAMES } from '../../utils/events'

@Component({
  selector: 'app-facephi-layout',
  templateUrl: './facephi-layout.component.html',
  styleUrls: ['./facephi-layout.component.scss'],
})
export class FacephiLayoutComponent implements OnInit, OnDestroy {
  storage = storage({
    storageType: EStorageType.SESSION,
    secretKey: environment.storage.key,
  })

  constructor(private router: Router) {}

  private handleOnValidateImage = (event: Event) => {
    const { detail } = event as CustomEvent<ValidateImageResponse>
    if (detail?.error) return
    else if ('url' in detail.data && detail.data.url) {
      this.storage.set(EVENT_NAMES.auth, detail.data)
      const url = new URL(detail.data.url)
      const navigatePath = url.pathname.split('/').slice(1)
      this.router.navigate(navigatePath, { replaceUrl: true })
    }
  }

  private handleOnMaxAttempts = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    this.router.navigate([flow, process], { replaceUrl: true })
  }

  private handleOnBack = () => {
    const flow = this.router.url.split('/')[1]
    const process = this.router.url.split('/')[2]
    this.router.navigate([flow, process], { replaceUrl: true })
  }

  ngOnInit(): void {
    this.storage.set(EVENT_NAMES.facephiConfig, { config: 'config' })
    window.addEventListener(EVENT_NAMES.facephiOnValidateImage, this.handleOnValidateImage)
    window.addEventListener(EVENT_NAMES.facephiOnMaxAttempts, this.handleOnMaxAttempts)
    window.addEventListener(EVENT_NAMES.facephiOnBack, this.handleOnBack)
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.facephiOnValidateImage, this.handleOnValidateImage)
    window.removeEventListener(EVENT_NAMES.facephiOnMaxAttempts, this.handleOnMaxAttempts)
    window.removeEventListener(EVENT_NAMES.facephiOnBack, this.handleOnBack)
  }
}
